import React from 'react'
import PropTypes from 'prop-types'
import './style.scss'

class VideoVC extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      trigger: false,
    }
    this.playVideo = this.playVideo.bind(this)
    this.pauseVideo = this.pauseVideo.bind(this)
  }

  playVideo() {
    $('.videobox').addClass('open')
    $('.videobox').find('#video').trigger('play')
  }

  pauseVideo() {
    $('.videobox').removeClass('open')
    $('.videobox').find('#video').trigger('pause')
  }

  render() {
    const { videoposter, videourl, overlaytext } = this.props

    return (
      <div className="dhsv_vc_video_container">
        <div className="dhsv_vc_video">
          <div
            className="videoposter"
            style={{ backgroundImage: `url(${videoposter})` }}
          ></div>
          <div className="dhsv_vc_video_overlay">
            <div className="dhsv_vc_video_overlaytext">{overlaytext}</div>
            <i
              className="play ion-ios-play-outline"
              onClick={this.playVideo}
            ></i>
          </div>
        </div>
        <div className="videobox">
          <div className="videocon">
            <div
              className="video"
              dangerouslySetInnerHTML={{
                __html: `<video controls poster="${videoposter}" id="video">
              <source src=${videourl} type="video/mp4" />
              </video>`,
              }}
            />
            <span onClick={this.pauseVideo}></span>
          </div>
        </div>
      </div>
    )
  }
}

VideoVC.propTypes = {
  videoposter: PropTypes.string,
  videourl: PropTypes.string,
  overlaytext: PropTypes.string,
}

export default VideoVC
